import { render, staticRenderFns } from "./m_submit.vue?vue&type=template&id=2c01a1aa&scoped=true&"
import script from "./m_submit.vue?vue&type=script&lang=js&"
export * from "./m_submit.vue?vue&type=script&lang=js&"
import style0 from "./m_submit.vue?vue&type=style&index=0&id=2c01a1aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c01a1aa",
  null
  
)

export default component.exports